import { LOCAL_STORAGE_AUTH_STATE_RECOVERY_AT } from '../constants';

// A recovery within this time of an earlier one, with no completed sign-in
// between them, is refused.
const STATE_RECOVERY_WINDOW_MS = 5 * 60_000;

// The mark must survive a browser that loses this tab's sessionStorage across
// the Identity redirect, so it is in localStorage and shared by every tab: a
// second tab recovering within the window shows the sign-in error page, whose
// Try again returns to its page.

export type StateRecovery = 'allowed' | 'repeated' | 'storage-blocked';

/** Marks a recovery reload, unless an earlier one is still pending or storage is blocked. */
export const startStateRecovery = (): StateRecovery => {
  try {
    const last = Number(
      localStorage.getItem(LOCAL_STORAGE_AUTH_STATE_RECOVERY_AT)
    );
    const now = Date.now();
    if (last && now - last >= 0 && now - last < STATE_RECOVERY_WINDOW_MS) {
      return 'repeated';
    }
    localStorage.setItem(LOCAL_STORAGE_AUTH_STATE_RECOVERY_AT, String(now));
    return 'allowed';
  } catch {
    return 'storage-blocked';
  }
};

/** Ends the pending recovery. */
export const clearStateRecovery = (): void => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_AUTH_STATE_RECOVERY_AT);
  } catch {
    // Blocked storage holds no mark.
  }
};
